const BAN_REPORT_ENRICHED = `
  fragment banReportEnrichedFields on BanReportEnriched {
    _id
    reportedUserId
    reportedUser {
      firstName
      lastName
      isBanned
    }
    reportedTeamId
    reportedTeam {
      name
    }
    reporterUserId
    reporterUser {
      firstName
      lastName
    }
    reason
    comment
    status
    strikeWeight
    decidedBy
    decisionNotes
    createdAt
    updatedAt
  }
`;

// Query list (enriched)
export const GET_BAN_REPORTS = `
${BAN_REPORT_ENRICHED}
  query (
    $term: String
    $status: BanReportStatus
    $reportedUserId: String
    $reporterUserId: String
    $sortingDir: String
    $sortingField: String
    $skip: Int
    $limit: Int
  ) {
    getBanReports(
      term: $term
      status: $status
      reportedUserId: $reportedUserId
      reporterUserId: $reporterUserId
      sortingDir: $sortingDir
      sortingField: $sortingField
      skip: $skip
      limit: $limit
    ) {
      ...banReportEnrichedFields
    }
  }
`;

// Review mutation (expects action enum)
export const REVIEW_BAN_REPORT = `
  mutation ($banReport: BanReportReviewInput!) {
    reviewBanReport(banReport: $banReport)
  }
`;

// Unban user mutation
export const UNBAN_USER = `
  mutation ($userId: String!) {
    unbanUser(userId: $userId)
  }
`;
